import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { IconCloudSolid } from '@roku-web-ui/rds-icons';

import styles from '../overlaysStyle.module.scss';

interface PoweredOffProps {
  connect: () => Promise<void>;
}

export const Disconnected = ({ connect }: PoweredOffProps) => (
  <Stack
    data-testid="camera-overlay-disconnected"
    direction="column"
    spacing={10}
    alignItems="center"
    justifyContent="center"
  >
    <IconCloudSolid className={styles.defaultIconSize} />
    <Typography variant="h3" className={styles.textSize}>
      Lost connection to camera
    </Typography>
    <Button
      aria-label="connect"
      data-testid="camera-overlay-button"
      variant="contained"
      onClick={() => {
        connect();
      }}
    >
      Reconnect
    </Button>
  </Stack>
);
